<section class="bk-panel st" aria-labelledby="st-title">
  <header class="st__head">
    <h2 class="bk-eyebrow" id="st-title">Sends</h2>
    @if (rows.length) {
      <span class="st__note">Open a send to see who received it</span>
    }
  </header>

  <data-table label="Campaign messages" [seamless]="true" [loading]="loading" [maxHeight]="'560px'" [skeletonColumns]="5" [skeletonRows]="4">
    @if (rows.length) {
      <table class="bk-log">
        <thead>
          <tr>
            <th scope="col">Message</th>
            <th scope="col" class="col-when">Send time</th>
            <th scope="col" class="col-status">Status</th>
            <th scope="col" class="num col-recipients">Recipients</th>
            <th scope="col" class="col-rate">Delivered</th>
            <th scope="col" class="col-go"><span class="bk-sr-only">Open</span></th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.key) {
            <tr class="is-link" tabindex="0" (click)="openReport(row)" (keydown.enter)="openReport(row)">
              <td class="col-msg">
                <span class="bk-msg">
                  <span class="bk-msg__subject">{{ row.message }}</span>
                  <span class="bk-msg__preview st__when-inline">{{ row.when }}</span>
                  @if (row.status) {
                    <!-- The status column folds in here on phones (only one of the two shows) -->
                    <span class="st__status-inline">
                      <app-status [text]="row.status" [status]="row.status" />
                    </span>
                  }
                </span>
              </td>
              <td class="quiet col-when">{{ row.when }}</td>
              <td class="col-status">
                @if (row.status) {
                  <app-status [text]="row.status" [status]="row.status" />
                } @else {
                  <span class="st__dash">—</span>
                }
              </td>
              <td class="num quiet col-recipients">{{ row.recipients }}</td>
              <td class="col-rate">
                @if (row.rate !== null) {
                  <span class="st__rate">
                    <span class="st__rate-value">{{ row.rate }}%</span>
                    <span class="st__rate-bar" aria-hidden="true">
                      <span class="st__rate-fill" [style.width.%]="row.rate"></span>
                    </span>
                  </span>
                } @else {
                  <span class="st__dash" title="Delivery shows once this send has gone out">—</span>
                }
              </td>
              <td class="col-go">
                <span class="bk-sym st__go" aria-hidden="true">chevron_right</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <app-empty-state
        icon="schedule_send"
        message="No sends yet"
        hint="Each scheduled send of each message is listed here once the campaign starts."
        size="medium"
      />
    }
  </data-table>
</section>
